export const BLOCKFI_ACCOUNTS = [
  '1000 Assets',
  '10100 Clearing Accounts',
  '10101 Deel Clearing Account',
  '10600 Traditional Bank Accounts',
  '10601 Signature Bank - LENDING LLC *5383',
  '10602 Signature Bank - LENDING LLC - Money Market - *1447',
  '10603 SIGNET',
  '10620 Silvergate INC - SEN *4191',
  '10621 Silvergate INC - Trading *4183',
  "10622 Silvergate Int'l - SEN *0776",
  '10624 Silvergate Lending LLC - Checking - *4091',
  '10625 Silvergate Lending LLC - SEN *4109',
  '10626 Silvergate TRADING LLC - (IN) *8523',
  '10627 Silvergate TRADING LLC - (OUT) *2277',
  '10628 Silvergate Trading LLC - ACH *4712',
  '10629 Silvergate Trading LLC - ACH Deposit *4704',
  '10630 Silvergate Trading LLC - ACH OUT *6799',
  '10631 Silvergate TRADING LLC - Ops * 8531',
  '10632 Silvergate TRADING LLC - SEN *8549',
  '10640 SVB Checking *0719',
  '10641 SVB Operating (LLC) *8628',
  '10699 Other Cash',
  '11000 AR',
  '11050 Equity Receivable',
  '11200 Intercompany Receivable',
  '11201 Intercompany Receivable - BlockFi Inc.',
  '11202 Intercompany Receivable - BlockFi Intl',
  '11203 Intercompany Receivable - BlockFi Lending',
  '11204 Intercompany Receivable - BlockFi Trading',
  '11300 Loan Receivable',
  '11350 Deferred Origination Fees',
  '11500 Interest Receivable',
  '11550 Rehyp Interest Receivable',
  '11600 Crypto Receivable',
  '12000 Crypto Inventory',
  '12001 BitGo',
  '12020 Gemini',
  '12021 Gemini - ATS',
  '12022 Gemini - BIA',
  '12030 LMAX Digital',
  '12040 Fidelity',
  '12050 Kraken',
  '12060 Coinbase',
  '12061 Coinbase - JW',
  '12062 Coinbase - Talos',
  '12070 ITBIT / PAXOS',
  '12080 Fireblocks',
  "12081 Fireblocks - Int'l12090",
  '38501 Ditributions - BlockFi Inc.',
  '39000 Additional Paid In Capital',
  '39100 SAFE Contributions',
  '39200 Financing Costs',
  '39999 Retained Earnings',
  '40000 Revenues',
  '40100 Interest Income',
  '40101 Rehyp Interest Income',
  '40150 Origination Fees',
  '40200 Processing Fees',
  '41000 BIA Fee Income',
  '42000 Trading Revenue',
  '50000 Expenses',
  '50100 Interest Expense on Loans',
  '50101 Loan Chargeoffs',
  '50200 Interest Expense on BIA',
  '50300 Financing Expense',
  '50400 Loan Servicing Fees',
  '50500 Credit Reports',
  '51000 G&A51001',
  'Rent & Lease51002 Maintenance',
  '51003 Office Supplies',
  'Tagomi13000 Investments',
  '13500 Futures Net Assets',
  '14000 Prepaid expenses',
  '14100 Security Deposits',
  '15000 Short-term Loans',
  '15500 Notes Receivable',
  '16000 Fixed Assets',
  '17000 Intangible Assets',
  '19000 Other Assets',
  '20000 Liabilities',
  '20100 Accounts Payable',
  '20201 Intercompany Payable',
  '20202 Intercompany Payable - BlockFi Inc.',
  '20203 Intercompany Payable - BlockFi Intl',
  '20204 Intercompany Payable - BlockFi Lending',
  '20205 Intercompany Payable - BlockFi Trading',
  '20999 Intercompany Payable',
  '21000 Accrued Financing Expenses',
  '22000 BIA Liability',
  '22500 Due to Counterparty',
  '22501 Due to Customer - ACH Withdrawals',
  '22502 Due to Customer - ACH Deposits',
  '22503 Due to Customer - Wire Withdrawals',
  '22504 Due to Customer - Wire Deposits',
  '23000 Collateral Due to Clients',
  '23500 Collateral Due to CP24000 Forwards/Swaps',
  '24500 OTC Settlements',
  '24700 Futures Net Liabilities',
  '25000 Loan Payable',
  '26000 Prepaid Income',
  '26300 Unsettled Trades',
  '26500 Unfunded Loans',
  '28000 Other Liabilities',
  '28100 Accrued Expenses',
  '28200 Payroll Clearing',
  '28201 Payroll Liabilities',
  '28202 Payroll Tax Payable',
  '28900 Treasury Stock Payable',
  '29000 Deferred Tax Liabilities',
  '30000 Retained Earnings',
  '31000 Common Stock',
  '32000 Preferred Stock',
  '33000 Treasury Stock',
  '38000 Member Capital',
  '38500 Contributions - BlockFi Inc.',
  '51004 Dues and Subscriptions',
  '51005 Utilities',
  '51006 Bank Fees & Charges',
  '51800 Insurance',
  '51900 Filing Fees',
  '52000 Salaries and Wages',
  '52001 Overtime',
  '52002 Benefits',
  '52003 Payroll Tax',
  '52004 Workers Comp',
  '52005 Stock-Based Compensation',
  '52006 Bonuses',
  '52900 Recruiting',
  '53000 Professional Fees - Consulting',
  '53001 Professional Fees - Accounting & Audit',
  '53002 Professional Fees - Public Relations',
  '53003 Professional Fees - Marketing Agency',
  '53004 Professional Fees - Recruiters',
  '53005 Professional Fees - Legal',
  '53006 Professional Fees - Payroll Service Fees',
  '54000 Sales and Marketing',
  '54001 Affiliate Fees',
  '54002 BIA Referral Bonuses',
  '54003 Loan Referral Bonus',
  '54004 Targeted Ads',
  '55000 Event Sponsorship',
  '55001 Podcasts',
  '55002 SEO55003 Written Content',
  '55900 Marketing & Other Promotional',
  '56000 Software and Technology',
  '56001 Cloud Computing',
  '56002 Systems Testing',
  '56003 Maintenance',
  '56004 Computer Supplies',
  '57000 Travel',
  '57001 Meals & Entertainment - 50%',
  '57002 Meals & Entertainment - 100%',
  '57003 Gifts and Donations',
  '57100 Conferences & Trade Events',
  '59000 Other Expense',
  '61000 Gain/Loss',
  '61001 Unrealized Gain/Loss',
  '62000 Amortization Expense',
  '62500 Depreciation Expense',
  '63000 Income Tax - Federal',
  '63001 Income Tax - State',
  '63500 Provision for Tax',
  '99999 Configuration Account - To be Inactivated',
]
//TODO: Need the list for uphold chart of accounts
export const UPHOLD_ACCOUNTS = [
  '1150.01 - Reserve Assets',
  '5875.1 - Digital Currencies',
  '1113.02 - B2C2 USD',
  '1113.07 - Bitstamp - USD',
  '5102 - FIAT',
  '5101 - Digital Currencies',
  '1150.01 - Clearing Account',
  '1113.08 - Bittrex - USD',
  '1113.01 - CBP US - USD',
  '1113.13 - Huobi - USD',
  '1113.04 - Kraken - USD',
  '1029 - Metropolitan 4341 Reserve USD',
  '2250.01 - Customer Holdings FIAT',
  '1150.02 - Reserve Assets Customer',
  '2250.02 - Customer Holdings Digital',
  '1150.03 Reserve Assets Fiat',
  '4303 - Digital Currencies - Network',
  '4203 - Cards',
  '4101 - Digital Currencies',
  '4302 - Digital Currencies-Fees',
  '4110.01 - Spread',
  '1113.14 - OkEx - USD',
]

export const BLOCKFI_SOURCES = [
  'Any',
  'Torch Borrows',
  'Torch Loans',
  'Torch Margin',
  'Torch Margin Borrows',
  'Fireblocks',
  'Thor',
  'Storm',
  'Gemini',
  'Coinbase',
  'Kraken',
  'Tagomi',
  'LMAX',
  'BitGo',
  'Deribit',
  'Fidelity',
  'ModernTreasury',
  'Paxos',
  'EDF',
  'LoanWatcher',
]

export const UPHOLD_SOURCES = [
  'Any',
  'Ledger',
  'LedgerVault',
  'TradeView',
  'Oanda',
  'Bittrex',
  'Bitstamp',
  'OkEx',
  'B2C2',
  'Coinbase',
  'Kraken',
  'Huobi',
]

export const ASSET_LIST = [
  { name: 'Any', value: '' },
  { name: 'Bitcoin', value: 'BTC' },
  { name: 'Ethereum', value: 'ETH' },
  { name: 'Uniswap', value: 'UNI' },
  { name: 'Litecoin', value: 'LTC' },
  { name: 'Chainlink', value: 'LINK' },
  { name: 'Basic Attention Token', value: 'BAT' },
  { name: 'PAX Gold', value: 'PAXG' },
  { name: 'Dai', value: 'DAI' },
  { name: 'Gemini dollar', value: 'GUSD' },
  { name: 'USD Coin', value: 'USDC' },
  { name: 'Binance USD', value: 'BUSD' },
  { name: 'Cardano', value: 'ADA' },
  { name: 'Tether', value: 'USDT' },
  { name: 'Stellar', value: 'XLM' },
  { name: 'Binance Coin', value: 'BNB' },
]

export const sourceCleaner = (source) => {
  const cleanSource = source?.includes('Torch')
    ? source.replace(/\s/g, '_')
    : source

  return cleanSource
}
